var _excluded = ["hiddenLink", "children"],
    _excluded2 = ["link", "activePage", "dropdownIconSize", "navLink"],
    _excluded3 = ["component", "hiddenLink", "icon"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28;

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React, { useState } from "react";
import styled, { css } from "styled-components";
import { colorBrandBase, colorLightest, colorWhite, colorDarkest, focusOutlineColor, focusOutlineOffset, focusOutlineStyle, focusOutlineWidth } from "@nib-components/theme";
import { PhoneSystemIcon, ChevronDownSystemIcon } from "@nib/icons";
import { Inline, Hidden, Container, breakpoint, map, p, px, py, m, mr } from "@nib/layout";
import Link from "@nib-components/link";
export var validVariationValues = ["arhi", "shareholders", "nz", "foundation", "thrive", "providers", "international", "internationalStudents", "internationalWorkers", "gu"];
export var HeaderWrapper = styled.header(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: none;\n  background-color: ", ";\n\n  ", "\n"])), colorWhite, breakpoint("xl")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n  "]))));
export var HeaderContainer = styled(Container)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  ", ";\n"])), py(4));
export var LogoLink = styled(Link).attrs({
  underline: false
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  &&& {\n    display: flex;\n    align-items: center;\n    ", ";\n\n    ", "\n  }\n\n  &:focus {\n    outline: ", " ", " ", ";\n    outline-offset: -", ";\n  }\n"])), p(4), breakpoint("xl", "xxl")(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      ", ";\n    "])), px(3)), focusOutlineWidth, focusOutlineStyle, focusOutlineColor, focusOutlineOffset);
LogoLink.displayName = "LogoLink";
export var HeaderContact = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
export var PhoneNumber = styled.a(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  font-size: 2rem;\n  font-weight: bold;\n  text-decoration: none;\n  color: ", ";\n\n  &:focus {\n    outline: ", " ", " ", ";\n    outline-offset: ", ";\n  }\n"])), colorBrandBase, focusOutlineWidth, focusOutlineStyle, focusOutlineColor, focusOutlineOffset);
export var PhoneIcon = styled(PhoneSystemIcon)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), colorBrandBase);
export var HeaderLinks = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"]))); // eslint-disable-next-line @typescript-eslint/no-unused-vars

export var SearchLink = styled(function (_ref) {
  var hiddenLink = _ref.hiddenLink,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("a", _extends({}, rest, {
    "aria-label": "Search"
  }), children);
})(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: ", ";\n  ", ";\n  ", ";\n  line-height: 0;\n  border: none;\n  background: transparent;\n  color: ", ";\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  &:focus {\n    outline: ", " ", " ", ";\n    outline-offset: ", ";\n  }\n"])), function (_ref2) {
  var hiddenLink = _ref2.hiddenLink;
  return hiddenLink ? "none" : "block";
}, mr(2), p(3), colorBrandBase, focusOutlineWidth, focusOutlineStyle, focusOutlineColor, focusOutlineOffset);
export var HeaderNav = styled.nav(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  color: ", ";\n  background-color: ", ";\n"])), colorDarkest, colorLightest);
export var NavMenu = styled.ul(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: flex;\n  ", ";\n  ", ";\n  list-style: none;\n\n  ", ";\n"])), m(0), px(0), function (_ref3) {
  var navAlignment = _ref3.navAlignment;
  return navAlignment && "justify-content: center";
});
export var NavItem = styled.li(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n\n  ", ";\n"])), function (_ref4) {
  var positionRight = _ref4.positionRight;
  return positionRight && "margin-left: auto";
});
NavItem.displayName = "NavItem";
export var baseNavLinkStyles = css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  // Button reset styles\n  appearance: none;\n  border: none;\n  background: none;\n  cursor: pointer;\n  margin: 0;\n\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  position: relative;\n  ", ";\n  font-size: 1rem;\n  font-weight: bold;\n  text-decoration: none;\n  color: ", ";\n\n  ", ":focus > &&,\n  ", ":hover > && {\n    color: ", ";\n  }\n\n  ", ":focus-within > && {\n    color: ", ";\n  }\n\n  &:focus {\n    outline: ", " ", " ", ";\n    outline-offset: -", ";\n    z-index: 1;\n  }\n"])), p(4), function (_ref5) {
  var color = _ref5.color;
  return color || "inherit";
}, NavItem, NavItem, colorBrandBase, NavItem, colorBrandBase, focusOutlineWidth, focusOutlineStyle, focusOutlineColor, focusOutlineOffset);
export var NavLink = styled.a(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  ", ";\n"])), baseNavLinkStyles);
NavLink.displayName = "NavLink";
export var DropdownContainer = styled.ul(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 2px;\n  box-shadow: 0px 4px 8px 0px hsla(0, 0%, 0%, 0.15); // Same as hero panel\n  ", ";\n  ", ";\n  ", ";\n  border-top: 4px solid ", ";\n  list-style: none;\n"])), colorWhite, m(0), p(0), py(4), colorBrandBase);
export var NavDropdown = styled.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: calc(100% - 4px);\n  ", ";\n\n  width: 17rem; // default for IE11\n\n  @supports (width: max-content) {\n    width: max-content;\n    max-width: 30rem;\n  }\n\n  z-index: 1;\n  height: 0;\n  overflow: hidden;\n\n  &::before {\n    content: '';\n    width: 0px;\n    height: 0px;\n    position: absolute;\n    border: 8px solid transparent;\n    border-bottom: 8px solid ", ";\n    top: 0;\n    transform: translateY(-100%);\n    ", ";\n  }\n\n  ", ":focus > &&,\n  ", ":hover > && {\n    height: auto;\n    overflow: visible;\n  }\n\n  ", ":focus-within > && {\n    height: auto;\n    overflow: visible;\n  }\n"])), function (_ref6) {
  var positionRight = _ref6.positionRight;
  return positionRight ? "right: 0" : "left: 0";
}, colorBrandBase, function (_ref7) {
  var positionRight = _ref7.positionRight;
  return positionRight ? "right: 2rem" : "left: 2rem";
}, NavItem, NavItem, NavItem);
export var NavDropdownLink = styled(Link).attrs({
  underline: false
})(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  &&& {\n    display: block;\n    ", ";\n    ", ";\n    color: inherit;\n\n    ", "\n  }\n\n  &:focus,\n  &:hover,\n  &:active {\n    color: ", ";\n    box-shadow: inset 4px 0px ", ";\n  }\n\n  ", "\n\n  &:focus {\n    outline: ", " ", " ", ";\n    outline-offset: -", ";\n  }\n"])), px(5), py(3), breakpoint("xl", "xxl")(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n      ", ";\n    "])), px(3)), colorBrandBase, colorBrandBase, function (_ref8) {
  var current = _ref8.current;
  return current && css(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n      color: ", ";\n      box-shadow: inset 4px 0px ", ";\n    "])), colorBrandBase, colorBrandBase);
}, focusOutlineWidth, focusOutlineStyle, focusOutlineColor, focusOutlineOffset);
export var NavDropdownSubLink = styled(NavDropdownLink)(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  padding-left: 2.5rem;\n"])));
NavDropdownSubLink.displayName = "NavDropdownSubLink";
export var NavDropdownHeading = styled.div(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  font-weight: bold;\n  ", ";\n  ", ";\n\n  ", "\n"])), px(5), py(3), breakpoint("xl", "xxl")(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n    ", ";\n  "])), px(3)));
export var DropdownIcon = styled(ChevronDownSystemIcon)(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  vertical-align: middle;\n\n  ", "\n\n  transform: translate(0deg);\n\n  ", ":focus &&,\n  ", ":hover && {\n    transform: rotate(180deg);\n  }\n\n  // FIXME: && here should fix things\n  ", ":focus-within && {\n    transform: rotate(180deg);\n  }\n"])), function (_ref9) {
  var breakpoints = _ref9.breakpoints;
  return map(breakpoints, function (val) {
    return css(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n          width: ", "px;\n          height: ", "px;\n        "])), val, val);
  });
}, NavItem, NavItem, NavItem);
var LineHeightOne = styled.span(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  line-height: 1;\n"])));
var NoWrapInline = styled(Inline)(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  flex-wrap: nowrap;\n  line-height: 0;\n"])));
export var NavLinkItem = function NavLinkItem(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  var link = props.link,
      activePage = props.activePage,
      _props$dropdownIconSi = props.dropdownIconSize,
      dropdownIconSize = _props$dropdownIconSi === void 0 ? 24 : _props$dropdownIconSi,
      navLink = props.navLink,
      otherProps = _objectWithoutProperties(props, _excluded2);

  var NavLink = navLink;
  var Icon = link.icon;
  return link.children ? /*#__PURE__*/React.createElement(NavItem, {
    positionRight: link.positionRight,
    onMouseEnter: function onMouseEnter() {
      return setIsExpanded(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsExpanded(false);
    },
    onFocus: function onFocus() {
      return setIsExpanded(true);
    },
    onBlur: function onBlur() {
      return setIsExpanded(false);
    }
  }, /*#__PURE__*/React.createElement(NavLink, _extends({
    id: "".concat(link.id, "-desktop"),
    title: link.title,
    href: link.url,
    target: link.targetBlank && "_blank",
    rel: link.targetBlank && "noopener noreferrer",
    "aria-expanded": isExpanded,
    "aria-haspopup": "true",
    "aria-current": activePage === link.slug ? "page" : null,
    isActivePage: activePage === link.slug
  }, otherProps), /*#__PURE__*/React.createElement(NoWrapInline, {
    space: 2,
    verticalAlign: "center"
  }, Icon ? /*#__PURE__*/React.createElement(Icon, {
    size: "md"
  }) : "", /*#__PURE__*/React.createElement(LineHeightOne, null, link.title), /*#__PURE__*/React.createElement(DropdownIcon, {
    breakpoints: {
      xl: 16,
      xxl: dropdownIconSize
    }
  }))), /*#__PURE__*/React.createElement(NavDropdown, {
    "aria-label": link.title,
    positionRight: link.positionRight
  }, /*#__PURE__*/React.createElement(DropdownContainer, null, link.children && link.children.map(function (child) {
    return /*#__PURE__*/React.createElement("li", {
      key: "".concat(child.id, "-desktop")
    }, /*#__PURE__*/React.createElement(NavDropdownLink, {
      id: "".concat(child.id, "-desktop"),
      title: child.title,
      href: child.url,
      target: child.targetBlank && "_blank",
      rel: child.targetBlank && "noopener noreferrer"
    }, child.title), child.children && /*#__PURE__*/React.createElement(NavMenu, {
      style: {
        flexDirection: "column"
      }
    }, child.children && child.children.map(function (subChild) {
      return /*#__PURE__*/React.createElement("li", {
        key: "".concat(subChild.id, "-desktop")
      }, /*#__PURE__*/React.createElement(NavDropdownSubLink, {
        id: "".concat(subChild.id, "-desktop"),
        title: subChild.title,
        href: subChild.url,
        target: subChild.targetBlank && "_blank",
        rel: subChild.targetBlank && "noopener noreferrer"
      }, /*#__PURE__*/React.createElement(Inline, {
        verticalAlign: "center",
        space: 2
      }, /*#__PURE__*/React.createElement(Hidden, {
        screenReader: true
      }, /*#__PURE__*/React.createElement("span", null, "\u2014")), /*#__PURE__*/React.createElement("span", null, subChild.title))));
    })));
  })))) : /*#__PURE__*/React.createElement(NavItem, {
    positionRight: link.positionRight
  }, /*#__PURE__*/React.createElement(NavLink, _extends({
    id: "".concat(link.id, "-desktop"),
    title: link.title,
    href: link.url,
    target: link.targetBlank && "_blank",
    rel: link.targetBlank && "noopener noreferrer",
    key: "".concat(link.id, "-desktop"),
    isActivePage: activePage === link.slug,
    "aria-current": activePage === link.slug ? "page" : null
  }, otherProps), /*#__PURE__*/React.createElement(NoWrapInline, {
    space: 2,
    verticalAlign: "center"
  }, Icon ? /*#__PURE__*/React.createElement(Icon, {
    size: "md"
  }) : "", /*#__PURE__*/React.createElement(LineHeightOne, null, link.title))));
};
NavLinkItem.displayName = "NavLinkItem"; // eslint-disable-next-line @typescript-eslint/no-unused-vars, jsx-a11y/anchor-has-content

export var HeaderLink = styled(function (_ref10) {
  var Component = _ref10.component,
      hiddenLink = _ref10.hiddenLink,
      icon = _ref10.icon,
      rest = _objectWithoutProperties(_ref10, _excluded3);

  return Component ? /*#__PURE__*/React.createElement(Component, rest) : /*#__PURE__*/React.createElement("a", rest);
})(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  display: ", ";\n  flex-direction: row;\n  align-items: center;\n  ", ";\n  border: none;\n  border-left: 1px solid ", ";\n  background: transparent;\n  color: ", ";\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  &:focus {\n    outline: ", " ", " ", ";\n    outline-offset: -", ";\n    z-index: 1;\n  }\n"])), function (_ref11) {
  var hiddenLink = _ref11.hiddenLink;
  return hiddenLink ? "none" : "flex";
}, p(4), colorLightest, colorBrandBase, focusOutlineWidth, focusOutlineStyle, focusOutlineColor, focusOutlineOffset);
export var SEARCH_URL = "/search";
HeaderLink.displayName = "HeaderLink";